import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../../toolkit/uicomponentcss';
import { Fonts } from '../../../../../utils/resources/fonts';
import { Colors } from '../../../../../utils/resources/colors';

export interface ManageBlacklistCSSStyle extends UIComponentCSSStyle {
    getBlacklistTitleCSSStyle(): object;
    getBlacklistNameCSSStyle(): object;
    getBlacklistMembersCSSStyle(): object;
    getButtonDivCSSStyle():object;
}

export class ManageBlacklistCSSStyleImpl extends UIComponentCSSStyleImpl implements ManageBlacklistCSSStyle 
{
 
    getWrapperCSSStyle(): object
    {
        return{
            width: "100%",
            textAlign: "center",
        };
    }

    getBlacklistNameCSSStyle(): object 
    {
        return {
            width:"55%", 
            minWidth: "250px",
            height:'30px', display: "inline-block",
            fontFamily:this.getContext().getResources().getFontFamily(),

        };
    }
    getBlacklistTitleCSSStyle(): object {
        return {

            textAlign: "center",
            fontSize: this.getResources().getFont(Fonts.h16),
            color: this.getResources().getColor(Colors.color_4),
            fontFamily: this.getResources().getFontFamily(),
            fontWeight: 900,
            letterSpacing: 0,
            lineHeight: "80px",
            boxSizing: "border-box",
            // height: "60px",
            width: "100%",
          };
    }

    getBlacklistMembersCSSStyle(): object {
       return {
            marginTop: "70px",
            width:"60%", 
            minWidth: "275px",
            marginLeft: "5%",
            // marginRight: this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? "0px",
            height: "100%",
            display: "inline-block"
       };
    }

    getButtonDivCSSStyle():object
    {
        return{
        width:'180px',
        marginTop: "30px",
        // marginLeft: this.getContext().getUserContext().getLanguage() === LanguageConst.BURMESE ? "3%" : "0%",
        marginRight:"3%"
        };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/blacklist/manageblacklist/manageblacklistcss.tsx